import { render, staticRenderFns } from "./PickupCard.vue?vue&type=template&id=373663e0&scoped=true&"
import script from "./PickupCard.vue?vue&type=script&lang=js&"
export * from "./PickupCard.vue?vue&type=script&lang=js&"
import style0 from "./PickupCard.vue?vue&type=style&index=0&id=373663e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373663e0",
  null
  
)

export default component.exports